import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { Row, Col, Button, Card, Space, Modal, Input, Image } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import AntdTable from '@/components/table/AntdTable'
import { scanResult, scanRecord, scanRecordDetail } from '../../../services/rfid/greyMarket/greyMarket'
import { modalError } from '@/utils/modalUtils'
import { formatMessageNew } from '@/utils/common'
import '@/css/market.less'
import Global_Combined from '@/assets/images/qrCode/Global_Combined.png'
import Local_QR_Code from '@/assets/images/qrCode/Local_QR_Code.png'
let imageInfo1 = {
  img: Global_Combined,
  w: 320,
  h: 76
}
let imageInfo2 = {
  img: Local_QR_Code,
  w: 76,
  h: 76
}
const GreyMarketScan = () => {
  const [inputValue, setInputValue] = useState('')
  const [gcInputValue, setGCInputValue] = useState('')
  const [nikeInputValue, setNikeInputValue] = useState('')
  const [scanResultList, setScanResultList] = useState([])
  const [tableList, setTableList] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [checkItem, setCheckItem] = useState(null)
  const [scanType, setScanType] = useState(1) // 1: EPC, 2: QR

  const tableColumns = [
    {
      title: '#',
      dataIndex: 'index',
      align: 'center',
      width: 100,
      render: (text, record, index) => index + 1
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.scanResult'),
      render: record => {
        const { upc, style, size, epc, gmScanTime } = record
        return (
          <Space direction="vertical" size="10" style={{ display: 'flex' }}>
            <strong className="scan-record-list-item">{`${upc || ''} ${style ? `${style}/` : ''}${size || ''}`}</strong>
            <span className="scan-record-list-item">{epc}</span>
            <span className="scan-record-list-item">
              {gmScanTime && dayjs(gmScanTime).format('YYYY-MM-DD HH:mm:ss')}
            </span>
          </Space>
        )
      }
    }
  ]

  const resultFields = [
    { key: 'upc', lanuageKey: 'upc', span: 8 },
    { key: 'sku', lanuageKey: 'style', span: 8 },
    { key: 'size', lanuageKey: 'size', span: 8 },
    { key: 'markFor', lanuageKey: 'markFor', span: 8 },
    { key: 'soldTo', lanuageKey: 'soldTo', span: 16 },
    { key: 'shipTo', lanuageKey: 'shipTo', span: 8 },
    {
      key: 'obScanTime',
      lanuageKey: 'obScanTime',
      span: 16,
      render: (text, record) => {
        return record && record.shipToType === 1 && text && dayjs(text).format('YYYY-MM-DD HH:mm:ss')
      }
    }
  ]

  useEffect(() => {
    getScanRecord()
  }, [])

  const getScanRecord = () => {
    scanRecord().then(res => {
      const dt = res.resultData
      const list = dt.map((item, idx) => ({ ...item, key: idx }))
      setTableList(list)
    })
  }

  const onSearch = () => {
    const params = { type: scanType }
    if (scanType === 1) {
      if (!inputValue) return
      let epcs = Array.from(new Set(inputValue.split(',')))
      epcs = epcs.map(item => item.trim())
      params.epcs = epcs
    } else {
      if (!gcInputValue && !nikeInputValue) return
      params.localQrCode = gcInputValue
      params.qrCode = nikeInputValue
    }
    scanResult(params)
      .then(res => {
        const dt = res.resultData
        setScanResultList(dt)
        getScanRecord()
        setInputValue('')
        setGCInputValue('')
        setNikeInputValue('')
        if (scanType !== 1) setScanType(1)
      })
      .catch(err => {
        setScanResultList([])
        setInputValue('')
        if (err.request && err.request.status === 401) {
          modalError({ content: formatMessageNew('languageObj.httpLocale.tokenInvalid') })
          return
        }
        if (err.errorCode === '1500') {
          modalError({ content: formatMessageNew('languageObj.greyMarketLocale.error1500') })
        } else if (err.errorCode === '4001') {
          modalError({ content: formatMessageNew('languageObj.defectiveReturnLocale.invalidQRCodeFormat') })
        } else if (err.errorCode === '436') {
          modalError({ content: formatMessageNew('languageObj.defectiveReturnLocale.noAssociatedEPC') })
        } else if (err.errorCode === '437') {
          modalError({ content: formatMessageNew('languageObj.defectiveReturnLocale.illegalQRCode') })
        } else if (err.errorCode === '5003') {
          modalError({ content: getErrorMessageHtml(err) })
        } else {
          modalError({ content: formatMessageNew('languageObj.httpLocale.requestError') })
        }
      })
  }
  const getErrorMessageHtml = (err = {}) => {
    let str = formatMessageNew('languageObj.greyMarketLocale.errorcode_' + err.errorCode)
    let resLs = []
    if (err.errorCode === '5003') {
      resLs.push(imageInfo1)
      resLs.push(imageInfo2)
    }
    let domStr = (
      <div>
        {str || err.errorMessage}
        <div className="displayFlex alignCenter justifyContentCenter mt5">
          {resLs.map((item, index) => {
            return (
              <div key={index} className="qr-code-img">
                <Image src={item.img} width={item.w} height={item.h} />
              </div>
            )
          })}
        </div>
      </div>
    )
    return domStr
  }
  const checkQrCode = () => {
    if (!gcInputValue && !nikeInputValue) return
    if (gcInputValue) {
      let valueUpperCase = gcInputValue.toUpperCase()
      if (valueUpperCase.indexOf('HTTPS') !== -1) {
        setNikeInputValue(gcInputValue)
        setGCInputValue('')
      }
    }
    if (nikeInputValue) {
      let valueUpperCase = nikeInputValue.toUpperCase()
      if (valueUpperCase.indexOf('HTTPS') === -1) {
        setNikeInputValue('')
        setGCInputValue(nikeInputValue)
      }
    }
  }

  const getRecordDetail = (record, index) => {
    let params = {
      epc: record.epc || '',
      localQrCode: record.localQrCode || ''
    }
    scanRecordDetail(params).then(res => {
      const dt = res.resultData
      dt.key = index
      setIsModalOpen(true)
      setCheckItem(dt)
    })
  }

  const renderResultView = record => {
    return (
      <Row>
        {resultFields.map(({ key, lanuageKey, span, render }, idx) => (
          <Col
            span={span}
            key={key}
            className="flex-column"
            style={{ marginBottom: `${idx < resultFields.length - 2 ? 10 : 0}px` }}
          >
            <span>{formatMessageNew(`languageObj.greyMarketLocale.${lanuageKey}`)}</span>
            <strong className="result-value">
              {render ? render(record && record[key], record) : (record && record[key]) || ''}
            </strong>
          </Col>
        ))}
      </Row>
    )
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setCheckItem(null)
  }

  const handleScanTypeChange = () => {
    setScanType(scanType === 1 ? 2 : 1)
    setInputValue('')
    // setScanResultList([])
    // setTableList([])
  }

  return (
    <div className="scan-wrapper">
      <div className="scan-content-wrapper">
        <div className="scan-top">
          <div className="search-wrapper alignStart">
            <div className="mr20 mt20">
              <Button
                className={`switch-btn-pc mt20 ${scanType === 1 ? 'switch-btn-qrCode' : 'switch-btn-epc'}`}
                onClick={handleScanTypeChange}
              >
                {`${formatMessageNew('languageObj.greyMarketLocale.switchTo')}
                ${scanType === 1 ? 'QR Code' : 'RFID EPC'}`}
              </Button>
            </div>
            <div className="w100">
              {scanType === 1 ? (
                <div className="mt20">
                  <Input
                    className="w100 mt20"
                    value={inputValue}
                    onChange={e => setInputValue(e.target.value)}
                    placeholder={formatMessageNew(`languageObj.greyMarketLocale.scanPlaceholderForWeb`)}
                    allowClear
                    onPressEnter={onSearch}
                  />
                </div>
              ) : (
                <div>
                  <div className="fontS14 color-ff5000 text-tips displayFlex alignEnd alignL pb3">
                    {formatMessageNew('languageObj.greyMarketLocale.scanTips1')}
                  </div>
                  <div>
                    <Input
                      value={gcInputValue}
                      onChange={e => {
                        setGCInputValue(e.target.value)
                      }}
                      placeholder={formatMessageNew(`languageObj.greyMarketLocale.qrCodeTips1`)}
                      allowClear
                      onPressEnter={checkQrCode}
                    />
                  </div>
                  <div className="fontS14 color-ff5000 text-tips displayFlex alignEnd alignL pb3">
                    {gcInputValue && gcInputValue.length >= 11
                      ? formatMessageNew('languageObj.greyMarketLocale.scanTips2')
                      : ''}
                  </div>
                  <div>
                    <Input
                      value={nikeInputValue}
                      onChange={e => setNikeInputValue(e.target.value)}
                      placeholder={formatMessageNew(`languageObj.greyMarketLocale.qrCodeTips2`)}
                      allowClear
                      onPressEnter={checkQrCode}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="mt20">
              <Button icon={<SearchOutlined />} className="mt20 ml20" type="primary" onClick={onSearch}>
                {formatMessageNew('languageObj.commonLocale.search')}
              </Button>
            </div>
          </div>
        </div>
        <div className="scan-result-list">
          <Space direction="vertical" size="middle" className="displayFlex">
            {scanResultList.map((item, idx) => (
              <Card key={idx} title={formatMessageNew('languageObj.greyMarketLocale.scanResult')} size="small">
                {renderResultView(item)}
              </Card>
            ))}
          </Space>
        </div>
      </div>
      <div className="scan-content-wrapper">
        <div className="scan-top scan-record-top">
          <span>{formatMessageNew('languageObj.greyMarketLocale.scanRecord')}</span>
          <span>
            {formatMessageNew('languageObj.greyMarketLocale.total')}:
            <span style={{ color: '#1677ff' }}> {tableList.length} </span>
            {formatMessageNew('languageObj.greyMarketLocale.results')}
          </span>
        </div>
        <div className="scan-record-list">
          <AntdTable
            dataSource={tableList}
            columns={tableColumns}
            pagination={false}
            rowClassName={(record, index) => {
              return checkItem && checkItem.key === record.key ? 'select-item-bg' : ''
            }}
            onRow={(record, index) => {
              return {
                onClick: event => {
                  getRecordDetail(record, index)
                }
              }
            }}
          />
        </div>
      </div>
      <Modal
        title={formatMessageNew('languageObj.greyMarketLocale.scanResult')}
        width={600}
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
      >
        {renderResultView(checkItem)}
      </Modal>
    </div>
  )
}

export default GreyMarketScan
